import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { EbookPreview } from './components/EbookPreview';
import { BenefitsSection } from './components/BenefitsSection';
import { ObjectionSection } from './components/ObjectionSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { LanguageProvider } from './context/LanguageContext';
import { LanguageToggle } from './components/LanguageToggle';
export function App() {
  return <LanguageProvider data-id="element-0">
      <main className="min-h-screen bg-white font-sans text-dark overflow-x-hidden relative" data-id="element-1">
        <LanguageToggle data-id="element-2" />
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <EbookPreview data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <ObjectionSection data-id="element-8" />
        <FinalCTA data-id="element-9" />
        <Footer data-id="element-10" />
      </main>
    </LanguageProvider>;
}